import { useEditor } from '@tiptap/react';
import { useMemo, useRef } from 'react';
import { VerdantExtension, } from './extensions/Verdant.js';
import { VerdantMediaExtension, } from './extensions/VerdantMedia.js';
export function useSyncedEditor(parent, fieldName, { editorOptions: extraOptions, editorDependencies, nullDocumentDefault, extensionOptions, files, } = {}) {
    var _a;
    const cachedOptions = useRef({
        nullDocumentDefault,
        extensionOptions,
    });
    cachedOptions.current = {
        nullDocumentDefault,
        extensionOptions,
    };
    // create a configured version of the Verdant extension, which handles
    // the actual syncing of the editor content to the field
    const extensions = useMemo(() => [
        VerdantExtension.configure(Object.assign({ parent, fieldName: fieldName, nullDocumentDefault }, cachedOptions.current.extensionOptions)),
        files
            ? VerdantMediaExtension.configure({
                fileMap: files,
            })
            : undefined,
    ].filter((v) => !!v), [fieldName, parent, files]);
    const editor = useEditor(Object.assign(Object.assign({}, extraOptions), { onContentError(props) {
            console.error('Content error:', props.error);
        }, extensions: [...extensions, ...((_a = extraOptions === null || extraOptions === void 0 ? void 0 : extraOptions.extensions) !== null && _a !== void 0 ? _a : [])] }), [...extensions, ...(editorDependencies !== null && editorDependencies !== void 0 ? editorDependencies : [])]);
    return editor;
}
//# sourceMappingURL=react.js.map